<template>
  <div class="page" :style="{ height: fixedHeight + 'px' }">
    <!-- 头部 -->
    <div class="titleView">
      <div style="margin-right: 20px; display: flex; align-items: center">
        <el-input
          v-model="keyword"
          prefix-icon="el-icon-search"
          placeholder="商品/条码/分拨单号"
          class="titleInput"
          clearable
          size="small"
        />
        <el-button
          type="warning"
          style="margin-left: 10px"
          @click="handleChange"
          size="small"
          >搜索</el-button
        >
      </div>
      <div class="flex" v-if="tabs == 1 || tabs == 2 || tabs == 3">
        <div style="margin-right: 10px">申请日期</div>
        <el-date-picker
          v-model="dateValue"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          class="titleDate"
          @change="handleChange"
          :default-time="['00:00:00', '23:59:59']"
          value-format="timestamp"
          style="width: 224px"
          size="small"
        />
      </div>
      <div class="flex" v-if="tabs == 1 || tabs == 2 || tabs == 3">
        <div style="margin-right: 10px">门店</div>
        <el-select
          v-model="shopValue"
          placeholder="请选择"
          class="titleSelect"
          @change="handleChange"
          style="width: 126px"
          size="small"
        >
          <el-option
            v-for="item in shopOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <div class="flex" v-if="tabs == 4">
        <div style="margin-right: 10px">配送门店</div>
        <el-select
          v-model="shopValue"
          placeholder="请选择"
          class="titleSelect"
          @change="handleChange"
          style="width: 126px"
          size="small"
        >
          <el-option
            v-for="item in shopOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <div class="flex" v-if="tabs == 4">
        <div style="margin-right: 10px">配送员</div>
        <el-select
          v-model="allocation_staff_id"
          placeholder="请选择"
          class="titleSelect"
          @change="handleChange"
          style="width: 126px"
          size="small"
        >
          <el-option
            v-for="item in staffList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <div class="flex" v-if="tabs == 4">
        <div style="margin-right: 10px">验收状态</div>
        <el-select
          v-model="acceptance_state"
          placeholder="请选择"
          class="titleSelect"
          @change="handleChange"
          style="width: 126px"
          size="small"
        >
          <el-option
            v-for="item in acceptanceState"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <div class="flex">
        <el-button @click="handleResetClick" size="small">重置</el-button>
      </div>
      <div
        style="text-align: right; flex: 1"
        v-if="tabs == 1 || tabs == 2 || tabs == 3"
      >
        <!-- <el-button type="primary">添加新品</el-button> -->
        <el-button @click="handleAddClick" size="small">新建采购单</el-button>
      </div>
    </div>
    <!-- tab切换 -->
    <!-- <div class="tabView">
			<el-button :class="tabs == 1?'active':'noactive'" @click="handleTabClick(1)" size="small">采购中</el-button>
			<el-button :class="tabs == 2?'active':'noactive'" @click="handleTabClick(2)" size="small">采购完成</el-button>
			<el-button :class="tabs == 3?'active':'noactive'" @click="handleTabClick(3)" size="small">采购取消</el-button>
		</div> -->

    <div class="tabLine">
      <div
        class="tabItem"
        :class="[tabs == 1 ? 'active' : '']"
        @click="handleTabClick(1)"
      >
        采购中
      </div>
      <div
        class="tabItem"
        :class="[tabs == 2 ? 'active' : '']"
        @click="handleTabClick(2)"
      >
        采购完成
      </div>
      <div
        class="tabItem"
        :class="[tabs == 3 ? 'active' : '']"
        @click="handleTabClick(3)"
      >
        采购取消
      </div>
      <div
        class="tabItem"
        :class="[tabs == 4 ? 'active' : '']"
        @click="handleTabClick(4)"
      >
        采购分拨
      </div>
    </div>
    <!-- 表格 -->
    <div class="tableView">
      <el-table
        :data="tableData"
        style="width: 100%"
        size="small"
        v-if="tabs == 1 || tabs == 2 || tabs == 3"
        key="1"
      >
        <el-table-column prop="procure_no" label="采购批次号" :key="1" />
        <el-table-column
          prop="add_info.create_time"
          label="采购申请日期"
          :key="2"
          :formatter="createTimeFormat"
        />
        <el-table-column
          prop="add_info.add_user_info.user_name"
          label="采购人"
          :key="3"
        />
        <el-table-column label="关联门店" :key="5" :formatter="shopsFormat" />
        <el-table-column
          prop="success_time"
          label="采购完成日期"
          :key="6"
          v-if="tabs == 2"
          :formatter="successTimeFormat"
        />
        <el-table-column
          prop="date"
          label="取消日期"
          :key="7"
          v-if="tabs == 3"
          :formatter="cancelTimeFormat"
        />
        <el-table-column
          prop="otherInfo.procureTotal"
          label="采购数量"
          :key="8"
          align="center"
        />
        <el-table-column
          prop="otherInfo.priceTotal"
          label="总价"
          :key="9"
          align="center"
        />
        <el-table-column
          prop="otherInfo.remarks"
          label="备注"
          :key="10"
          align="center"
          v-if="tabs == 1"
        >
          <template slot-scope="scope">
            <span>{{
              scope.row.remarks == "" ? "--" : scope.row.remarks
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" :key="11" align="center">
          <template slot-scope="scope">
            <el-button
              @click="handleSetClick(scope.row)"
              type="text"
              size="small"
              >{{ tabs == 1 ? "编辑" : "查看" }}
            </el-button>
            <el-button
              type="text"
              size="small"
              @click="handleCanleClick(scope.row)"
              v-if="tabs == 1"
              >取消
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 采购分拨 -->
      <el-table
        :data="tableData"
        style="width: 100%"
        size="small"
        v-if="tabs == 4"
        key="2"
      >
        <el-table-column prop="distribution_no" label="分拨批次号" :key="21" />
        <el-table-column prop="create_time" label="分拨日期" :key="22">
          <template slot-scope="scope">
            {{ $public.FTime(scope.row.create_time, "YYYY-MM-DD") }}
          </template>
        </el-table-column>
        <el-table-column
          prop="company_info.shop_name"
          label="分拨门店"
          :key="23"
        />
        <el-table-column label="分拨人" :key="25" prop="add_user.user_name" />
        <el-table-column label="配送人" :key="26">
          <template slot-scope="scope">
            {{
              scope.row.logistics == null || scope.row.logistics.staff == null
                ? ""
                : scope.row.logistics.staff.staff_name
            }}
          </template>
        </el-table-column>

        <el-table-column prop="date" label="配送状态" :key="27">
          <template slot-scope="scope">
            <div v-if="scope.row.state == 1">已验收</div>
            <div v-if="scope.row.state == 2">部分验收</div>
            <div v-if="scope.row.state == 3">未验收</div>
            <div v-if="scope.row.state == 4">未配送</div>
            <div v-if="scope.row.state == 5">配送中</div>
            <div v-if="scope.row.state == 6">已送达</div>
          </template>
        </el-table-column>
        <el-table-column label="送达日期" :key="28" align="center">
          <template slot-scope="scope">
            {{
              scope.row.logistics == null ||
              scope.row.logistics.delivery_success == null
                ? ""
                : $public.FTime(
                    scope.row.logistics.delivery_success.opearation_time,
                    "YYYY-MM-DD"
                  )
            }}
          </template>
        </el-table-column>
        <el-table-column label="验收日期" :key="30" align="center">
          <template slot-scope="scope">
            {{
              scope.row.received_goods == null ||
              scope.row.received_goods.length == 0
                ? ""
                : $public.FTime(
                    scope.row.received_goods[
                      scope.row.received_goods.length - 1
                    ].received_time,
                    "YYYY-MM-DD"
                  )
            }}
          </template>
        </el-table-column>
        <el-table-column label="操作" :key="31" align="center">
          <template slot-scope="scope">
            <el-button
              @click="inspectionLook(scope.row.distribution_no)"
              type="text"
              size="small"
              >查看
            </el-button>
            <el-button
              type="text"
              size="small"
              @click="handleDeliveryClick(scope.row, 1)"
              v-if="scope.row.state == 3"
              >配送</el-button
            >
            <el-button
              type="text"
              size="small"
              @click="handleDeliveryClick(scope.row, 2)"
              v-if="scope.row.state == 4"
              >修改配送</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <page
        :page="page.page"
        :total="page.total"
        @change="changePage"
        style="padding: 10px 0"
      ></page>
    </div>
    <el-dialog
      title="是否取消该次采购单"
      :visible.sync="dialogFormVisible"
      width="557px"
    >
      <el-input
        v-model="cancelValue"
        autocomplete="off"
        type="textarea"
        placeholder="请输入5字以上"
        show-word-limit
        rows="6"
        resize="none"
      />
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleComClick">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="deliveryName"
      :visible.sync="dialogDeliveryVisible"
      width="300px"
    >
      <div style="display: flex; justify-content: center">
        <el-select v-model="staffId" placeholder="请选择配送人员">
          <el-option
            v-for="item in staffList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubClick">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 查看分拨单 -->
    <el-dialog
      title="验货查看"
      :visible.sync="dialogaccept"
      :close-on-click-modal="false"
      width="90%"
    >
      <div class="titlecon" v-if="inspectionDetail">
        <div class="titleleft">
          <span>分拨批次号: {{ inspectionDetail.distribution_no }}</span>
          <span>分拨人: {{ inspectionDetail.add_user.user_name }}</span>
          <span v-if="inspectionDetail.add_info"
            >分拨人 {{ inspectionDetail.add_user.user_name }}</span
          >
          <span
            >分拨时间: {{ $public.FTime(inspectionDetail.create_time) }}</span
          >
          <span>分拨数量: {{ distributionCount }}</span>
          <span
            >状态:
            <span style="color: #2a2a2a" v-if="inspectionDetail.state == 1"
              >已验收</span
            >
            <span style="color: #ffae11" v-if="inspectionDetail.state == 2"
              >部分验收</span
            >
            <span style="color: #ff182a" v-if="inspectionDetail.state == 3"
              >未验收</span
            >
            <span style="color: #ff182a" v-if="inspectionDetail.state == 4"
              >未配送</span
            >
            <span style="color: #ff182a" v-if="inspectionDetail.state == 5"
              >配送中</span
            >
            <span style="color: #ff182a" v-if="inspectionDetail.state == 6"
              >已送达</span
            >
          </span>
          <div>
            <span
              v-if="
                inspectionDetail.received_goods &&
                inspectionDetail.received_goods.length > 0
              "
            >
              验收人:
              {{
                inspectionDetail.received_goods[
                  inspectionDetail.received_goods.length - 1
                ].success_user_info.user_name
              }}</span
            >
            <span
              v-if="
                inspectionDetail.received_goods &&
                inspectionDetail.received_goods.length > 0
              "
            >
              验收时间:
              {{
                $public.FTime(
                  inspectionDetail.received_goods[
                    inspectionDetail.received_goods.length - 1
                  ].received_time
                )
              }}</span
            >
            <span
              v-if="
                inspectionDetail.received_goods &&
                inspectionDetail.received_goods.length > 0
              "
            >
              验收数量:
              {{
                inspectionDetail.received_goods[
                  inspectionDetail.received_goods.length - 1
                ].received_count
              }}</span
            >
          </div>
          <div></div>
        </div>
      </div>
      <div v-for="(item, index) in sumData" :key="index">
        <div class="comH2" @click="handleShopClick(item.goods_type)">
          <div>
            {{
              item.goods_type == 1
                ? "医疗类"
                : item.goods_type == 0
                ? "商品类"
                : "耗材类"
            }}
          </div>
          <i
            v-if="showType['showType' + item.goods_type]"
            class="el-icon-caret-bottom"
          ></i>
          <i v-else class="el-icon-caret-top"></i>
        </div>
        <el-table
          row-class-name="row-expand-cove"
          :ref="'table' + item.goods_type"
          v-show="showType['showType' + item.goods_type]"
          show-summary
          :data="item.goods"
          style="width: 100%"
          size="small"
        >
          <el-table-column label="商品名称">
            <template slot-scope="scope">
              <span>{{ scope.row.goods.title }}</span>
            </template>
          </el-table-column>
          <el-table-column label="品牌">
            <template slot-scope="scope">
              <span>{{ scope.row.goods.brand }}</span>
            </template>
          </el-table-column>
          <el-table-column label="规格">
            <template slot-scope="scope">
              <span>{{ scope.row.goods.sku_value }}</span>
            </template>
          </el-table-column>
          <el-table-column label="单位" width="60">
            <template slot-scope="scope">
              <span>{{ scope.row.goods.in_unit }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="分拨数量"
            prop="distribution_count"
           
          >
            <template slot-scope="scope">
              <span>{{ scope.row.distribution_count }}</span>
            </template>
          </el-table-column>

          <el-table-column label="成本价" prop="cost_price">
            <template slot-scope="scope">
              <span>{{ scope.row.cost_price }}</span>
            </template>
          </el-table-column>

          <el-table-column label="有效期" prop="count" width="100">
            <template slot-scope="scope">
              <span>{{
                scope.row.distribution_datas_list.length > 1
                  ? "多效期"
                  : $public.FTime(
                      scope.row.distribution_datas_list[0].overdue_time,
                      "YYYY-MM-DD"
                    )
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="实收数量" width="100" prop="acceptance_count">
            <template slot-scope="scope">
              <span class="">{{ scope.row.acceptance_count }}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" width="80">
            <template slot-scope="scope">
              <span
                v-if="
                  scope.row.distribution_count == scope.row.acceptance_count
                "
              >
                <span style="color: #13ce66">•</span>
                已验收
              </span>
              <span
                v-if="
                  scope.row.distribution_count > scope.row.acceptance_count &&
                  scope.row.acceptance_count != 0
                "
              >
                <span style="color: #13ce66">•</span>
                部分验收
              </span>
              <span v-if="scope.row.acceptance_count == 0">
                <span style="color: #e6a23c">•</span>
                未验收
              </span>
              <span
                v-if="
                  scope.row.acceptance_info &&
                  scope.row.acceptance_info.abnormal_info &&
                  (scope.row.acceptance_info.abnormal_info.leakage_count ||
                    scope.row.acceptance_info.abnormal_info.overdue_count ||
                    scope.row.acceptance_info.abnormal_info.broken_count ||
                    scope.row.acceptance_info.abnormal_info.switch_count)
                "
              >
                <span style="color: #ff4d51">•</span>
                异常
                {{
                  scope.row.acceptance_info.abnormal_info.leakage_count +
                  scope.row.acceptance_info.abnormal_info.overdue_count +
                  scope.row.acceptance_info.abnormal_info.broken_count +
                  scope.row.acceptance_info.abnormal_info.switch_count
                }}
                <el-popover
                  popper-class="abnormalpopover"
                  placement="bottom"
                  trigger="click"
                >
                  <div class="abnormal">
                    <div>
                      漏发数量
                      {{
                        scope.row.acceptance_info.abnormal_info.leakage_count
                      }}
                    </div>
                    <div>
                      过期数量
                      {{
                        scope.row.acceptance_info.abnormal_info.overdue_count
                      }}
                    </div>
                    <div>
                      破损数量
                      {{ scope.row.acceptance_info.abnormal_info.broken_count }}
                    </div>
                    <div>
                      调换数量
                      {{ scope.row.acceptance_info.abnormal_info.switch_count }}
                    </div>
                  </div>
                  <el-button
                    slot="reference"
                    type="text"
                    icon="el-icon-view"
                  ></el-button>
                </el-popover>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="验收状态" width="100">
            <template slot-scope="scope">
              <span
                v-if="
                  scope.row.distribution_count == scope.row.acceptance_count
                "
              >
                <span style="color: #13ce66">•</span>
                已验收 {{ scope.row.acceptance_count }} /
                {{ scope.row.distribution_count }}
              </span>
              <span
                v-if="
                  scope.row.distribution_count > scope.row.acceptance_count &&
                  scope.row.acceptance_count != 0
                "
              >
                <span style="color: #13ce66">•</span>
                部分验收 {{ scope.row.acceptance_count }} /
                {{ scope.row.distribution_count }}
              </span>
              <span v-if="scope.row.acceptance_count == 0">
                <span style="color: #e6a23c">•</span>
                未验收 {{ scope.row.acceptance_count }} /
                {{ scope.row.distribution_count }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="toogleExpand(scope.row)"
                size="small"
              >
                查看条码
              </el-button>
            </template>
          </el-table-column>

          <el-table-column type="expand" width="1">
            <template slot-scope="props">
              <div
                class="goodscustom"
                v-for="(item, index) in props.row.distribution_datas_list"
                :key="index"
              >
                <div>
                  有效期
                  {{ $public.FTime(item.overdue_time, "YYYY-MM-DD") }} 条码数量
                  {{ item.code_count }}
                </div>
                <div style="margin-top: 10px">
                  <el-tag
                    style="margin: 5px"
                    v-for="(goodscustom, subindex) in fillterGoodsCustom(
                      item.goods_code_list
                    )"
                    :key="subindex"
                    :type="
                      goodscustom.is_check || goodscustom.goods_state == 4
                        ? 'success'
                        : 'info'
                    "
                  >
                    {{ goodscustom.code }}
                    总量 {{ goodscustom.totaltimes }}
                  </el-tag>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { caigouList, cancelCaigou } from "@/api/purchaseApi.js";
import { getDistributionInfo } from "@/api/shopPurchaseApi.js";
import page from "../../../components/page.vue";
export default {
  components: {
    page,
  },
  data() {
    return {
      fixedHeight: "",
      page: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      keyword: "",
      cancelValue: "", //取消理由
      dialogFormVisible: false,
      tableData: [], //商品数据
      tabs: 1,
      shopOptions: [
        {
          //门店筛选
          value: "",
          label: "全部",
        },
        {
          value: "5e9412e0b2bfbc089daerr12",
          label: "金水区店",
        },
        {
          value: "5e9412e0b2bfbc089daerr18",
          label: "郑东新区店",
        },
        {
          value: "5e9412e0b2bfbc089daerr14",
          label: "指挥中心店",
        },
        {
          value: "5e9412e0b2bfbc089daerr17",
          label: "线上旗舰店",
        },
        {
          value: "5e9412e0b2bfbc089daerr10",
          label: "驯养中心",
        },
        {
          value: "5e9412e0b2bfbc089daerr11",
          label: "小程序",
        },
      ],
      serchValue: "", //输入框筛选
      dateValue: null, //采购申请日期
      shopValue: "", //门店筛选
      textValue: "", //取消理由
      cancelId: "", //取消采购单id
      acceptance_state: -1, //分拨状态
      acceptanceState: [
        {
          //门店筛选
          value: -1,
          label: "全部",
        },
        {
          value: 1,
          label: "已验收",
        },
        {
          value: 2,
          label: "部分验收",
        },
        {
          value: 3,
          label: "未验收",
        },
        {
          value: 4,
          label: "未配送",
        },
        {
          value: 5,
          label: "配送中",
        },
        {
          value: 6,
          label: "已送达",
        },
      ],
      allocation_staff_id: "", //配送员id
      dialogaccept: false,
      inspectionDetail: "",
      sumData: [],
      showType: {
        showType0: true,
        showType1: true,
        showType7: true,
        showType3: true,
      },
      dialogDeliveryVisible: false,
      deliveryName: "",
      staffList: [],
      staffId: "",
      distribution_no: "",
      deliveryType: 0,
    };
  },
  created() {
    let that = this;
    this.fixedHeight = document.documentElement.clientHeight - 76;
    document.onkeydown = function () {
      var key = window.event.keyCode;
      if (key == 13) {
        that.getTableData();
      }
    };
  },
  computed: {
    //计算分拨总数量
    distributionCount() {
      let distributionCount = 0;
      this.inspectionDetail.linkData.forEach((item) => {
        distributionCount += item.distribution_count;
      });
      return distributionCount;
    },
  },
  mounted() {
    if (sessionStorage.getItem("cgtabs")) {
      console.log("缓存", sessionStorage.getItem("cgtabs"));
      this.tabs = sessionStorage.getItem("cgtabs");
      this.serchValue = "";
      this.dateValue = null;
      this.shopValue = "";
      this.page = {
        page: 1,
        pageSize: 10,
        total: 0,
      };
    }
    this.getTableData();
    this.getDeliveryList();
    sessionStorage.removeItem("cgtabs");
  },
  methods: {
    //提交
    handleSubClick() {
      if (this.staffId == "") {
        this.$message({
          message: "请选择配送员",
          type: "warning",
        });
        return;
      }
      let params = {};
      params.distribution_no = this.distribution_no;
      params.remark = "";
      this.staffList.map((item) => {
        if (item.value == this.staffId) {
          params.staff = {
            staff_id: item.value,
            staff_name: item.label,
          };
        }
      });
      console.log(params);
      if (this.deliveryType == 1) {
        this.$http
          .post(process.env.VUE_APP_Url4 + "api/Procure/AddAllocation", params)
          .then((res) => {
            console.log("分拨列表", res);
            if (res.code == 0) {
              this.$message({
                message: "已添加配送员",
                type: "success",
              });
              this.getFenboList();
              this.dialogDeliveryVisible = false;
            }
          });
      } else {
        this.$http
          .post(
            process.env.VUE_APP_Url4 + "api/Procure/UpdateAllocation",
            params
          )
          .then((res) => {
            console.log("分拨列表", res);
            if (res.code == 0) {
              this.$message({
                message: "已修改配送员",
                type: "success",
              });
              this.getFenboList();
              this.dialogDeliveryVisible = false;
            }
          });
      }
    },
    //获取配送列表
    getDeliveryList() {
      this.$http
        .get(process.env.VUE_APP_Url2 + "api/StaffInfo/distribution/list")
        .then((res) => {
          if (res.code == 0) {
            console.log("配送列表", res);
            this.staffList = res.data;
          }
        });
    },
    //配送
    handleDeliveryClick(row, type) {
      console.log(row);
      this.staffId = "";
      if (type == 1) {
        this.deliveryName = "选择配送员";
      } else {
        this.deliveryName = "修改配送员";
        this.staffId = row.logistics.staff.staff_id;
      }
      this.deliveryType = type;
      this.distribution_no = row.distribution_no;
      this.dialogDeliveryVisible = true;
    },
    handleShopClick(type) {
      this.showType["showType" + type] = !this.showType["showType" + type];
    },
    fillterGoodsCustom(arry) {
      let custtomList = arry.filter((item) => {
        return item.is_check == true || item.goods_state == 4;
      });

      return custtomList;
    },
    toogleExpand(row) {
      let $table = this.$refs["table" + row.goods.goods_type][0];
      $table.toggleRowExpansion(row);
    },
    sumGoods(arry) {
      let sumData = [];
      arry.forEach((item) => {
        let index = sumData.findIndex((ele) => {
          return item.goods.goods_type == ele.goods_type;
        });
        if (index == -1) {
          sumData.push({
            goods_type: item.goods.goods_type,
            goods: [item],
          });
        } else {
          sumData[index].goods.push(item);
        }
      });
      return sumData;
    },
    inspectionLook(id) {
      getDistributionInfo({
        distribution_no: id,
      }).then((res) => {
        if (res.code == 0) {
          this.inspectionDetail = res.data;
          this.sumData = this.sumGoods(res.data.linkData);
          console.log("数据", this.sumData);
        }
      });
      this.dialogaccept = true;
    },
    //分拨列表
    getFenboList() {
      let params = {
        page_index: this.page.page,
        page_size: this.page.pageSize,
        keyword: this.keyword,
        acceptance_state: this.acceptance_state,
        allocation_staff_id: this.allocation_staff_id,
        shop_id: this.shopValue,
      };
      this.$http
        .post(
          process.env.VUE_APP_Url4 + "api/Procure/GetShopAcceptanceList",
          params
        )
        .then((res) => {
          console.log("分拨列表", res);
          if (res.code == 0) {
            this.tableData = res.data.data;
            this.page.total = res.data.count;
          }
        });
    },
    //编辑
    handleSetClick(row) {
      console.log(row.procure_no);
      let query = {
        id: row.procure_no,
        cgtabs: this.tabs,
      };
      if (this.tabs == 1) {
        console.log("采购中");
        this.$router.push({
          path: "cgzDetail",
          query,
        });
      }
      if (this.tabs == 2) {
        console.log("采购完成");
        this.$router.push({
          path: "cgwcDetail",
          query,
        });
      }
      if (this.tabs == 3) {
        console.log("采购取消");
        this.$router.push({
          path: "cgwcDetail",
          query,
        });
      }
    },
    //取消采购单确认按钮
    handleComClick() {
      if (this.cancelValue.length < 5) {
        this.$message({
          message: "请输入5字以上",
          type: "warning",
        });
        return;
      }
      let parmars = {
        id: this.cancelId,
        remark: this.cancelValue,
      };
      cancelCaigou(parmars).then((res) => {
        if (res.code == 0) {
          this.$message({
            message: "已取消",
            type: "success",
          });
          this.dialogFormVisible = false;
          this.textValue = "";
          this.getTableData();
        }
      });
    },
    //格式化门店
    shopsFormat(row) {
      // console.log(row.procure_request_simples_list.length)
      if (row.procure_request_simples_list.length == 0) {
        return "总部";
      } else {
        let storeStr = "";
        let storeArr = [];
        for (let i = 0; i < row.procure_request_simples_list.length; i++) {
          switch (
            row.procure_request_simples_list[i].add_info.company_info.shop_id
          ) {
            case "5e9412e0b2bfbc089daerr12":
              storeArr.push("金水区店 ");
              break;
            case "5e9412e0b2bfbc089daerr14":
              storeArr.push("指挥中心店 ");
              break;
            case "5e9412e0b2bfbc089daerr17":
              storeArr.push("线上旗舰店 ");
              break;
            case "5e9412e0b2bfbc089daerr10":
              storeArr.push("驯养中心 ");
              break;
              case "5e9412e0b2bfbc089daerr18":
              storeArr.push("郑东新区店");
              break;
            case "5e9412e0b2bfbc089daerr11":
              storeArr.push("小程序 ");
              break;
          }
        }
        storeArr = [...new Set(storeArr)];
        for (let j = 0; j < storeArr.length; j++) {
          storeStr += storeArr[j];
        }
        // console.log(storeArr,storeStr);
        return storeStr;
      }
    },
    //新建采购单
    handleAddClick() {
      this.$router.push({
        path: "addcaigou",
      });
    },
    //格式化取消日期
    cancelTimeFormat(row) {
      if (row.cancel_info != null) {
        let date = Number(row.cancel_info.cancel_time) * 1000;
        if (date === undefined) {
          return "";
        }
        let moment = require("moment");
        return moment(date).format("YYYY-MM-DD");
      }
    },
    //格式化采购日期
    createTimeFormat(row) {
      let date = Number(row.add_info.create_time) * 1000;
      if (date === undefined) {
        return "";
      }
      let moment = require("moment");
      return moment(date).format("YYYY-MM-DD");
    },
    //格式化采购完成日期
    successTimeFormat(row) {
      if (row.success_info != null) {
        let date = Number(row.success_info.success_time) * 1000;
        if (date === undefined) {
          return "";
        }
        let moment = require("moment");
        return moment(date).format("YYYY-MM-DD");
      } else {
        return "";
      }
    },
    // 取消按钮
    handleCanleClick(row) {
      this.dialogFormVisible = true;
      this.cancelId = row.procure_no;
    },
    //重置
    handleResetClick() {
      this.keyword = "";
      this.shopValue = "";
      if (this.tabs == 1 || this.tabs == 2 || this.tabs == 3) {
        this.dateValue = null;
        this.getTableData();
      } else if (this.tabs == 4) {
        this.allocation_staff_id = "";
        this.acceptance_state = -1;
        this.getFenboList();
      }
    },
    //tab切换
    handleTabClick(index) {
      this.tabs = index;
      this.serchValue = "";

      this.shopValue = "";
      this.page.page = 1;
      if (this.tabs == 1 || this.tabs == 2 || this.tabs == 3) {
        this.dateValue = null;
        this.getTableData();
      } else if (this.tabs == 4) {
        this.allocation_staff_id = "";
        this.acceptance_state = -1;
        this.getFenboList();
      }
    },
    //筛选切换
    handleChange() {
      if (this.tabs == 1 || this.tabs == 2 || this.tabs == 3) {
        this.getTableData();
      } else if (this.tabs == 4) {
        this.getFenboList();
      }
    },
    //分页方法
    changePage(num) {
      this.page.page = num;
      if (this.tabs == 1 || this.tabs == 2 || this.tabs == 3) {
        this.getTableData();
      } else if (this.tabs == 4) {
        this.getFenboList();
      }
    },
    //获取商品详情
    getTableData() {
      // console.log(this.serchValue)
      let stateStr = 0;
      if (this.tabs == 1) {
        stateStr = 1;
      } else if (this.tabs == 2) {
        stateStr = 3;
      } else if (this.tabs == 3) {
        stateStr = 4;
      }
      let startTime = "";
      let endTime = "";
      if (this.dateValue != null) {
        startTime = this.dateValue[0] / 1000;
        endTime = this.dateValue[1] / 1000;
      } else {
        startTime = "";
        endTime = "";
      }
      let parmars = {
        page_index: this.page.page, //当前页
        page_size: this.page.pageSize, //每页条数
        keyword: this.keyword, //关键字
        state: stateStr, //状态   1采购中  3采购完成 4采购取消
        shop_id: this.shopValue, //门店id
        starttime: startTime, //开始时间
        endtime: endTime, //结束时间
      };
      caigouList(parmars).then((res) => {
        if (res.code == 0) {
          console.log("商品列表", res);
          this.tableData = res.data.data;
          this.page.total = res.data.count;
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
.page {
  display: flex;
  flex-direction: column;

  .flex {
    display: flex;
    align-items: center;
    margin-right: 10px;
  }

  .titleView {
    background: #fff;
    height: 72px;
    display: flex;
    align-items: center;
    font-size: 14px;
    padding: 0 10px;
  }

  .tabLine {
    display: flex;
    margin: 10px 0;

    .tabItem {
      width: 100px;
      box-sizing: border-box;
      line-height: 36px;
      text-align: center;
      border-right: 1px solid #f2f2f2;
      cursor: pointer;
      font-size: 14px;
      background-color: #fff;

      &.active {
        color: $mainColor;
      }
    }
  }

  .tabView {
    margin: 20px 0;
  }

  .tableView {
    flex: 1;
    background: #fff;
    overflow: hidden;
  }

  .active {
    background: #f5882a;
    color: #fff;
  }

  .noactive {
    background: #fff;
    color: #000;
  }

  .titlecon {
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex: 1;
    background-color: #f5f5f5;
    padding: 5px 0;
    border-radius: 5px;

    .titleleft {
      span {
        margin: 5px 20px;
        display: inline-block;
      }
    }

    .titleright {
      width: 300px;
      // margin-top: 20px;
    }
  }

  .comH2 {
    line-height: 64px;
    font-size: 18px;
    display: flex;
    align-items: center;
  }
}
</style>
